module.exports = __webpack_public_path__ + "static/media/military-tech.4a67e4cc.svg";